<label for="txtDate" id="lblTxtDate" [ngClass]="{'col-4': isInline, 'required-label': isRequired && !!dateControlName}">{{dateControlName}}</label>
<div class="form-group__button-input">
  <input #txtDate id="txtDate" type="text" class="form-control" [imask]="dateMask" (change)="onChange($event)" (keyup)="onChange($event)"
    [disabled]="disabled" placeholder="{{defaultDateFormatDisplay}}" tabindex="{{tabIndex}}" (blur)="onBlur($event)"
    [ngClass]="{'required': isRequired && showRequiredIndicator, 'is-error': hasError}" [value]="selectedDate">
  @if (hasError) {
    <div class="touch-error__wrapper">
      <div class="touch-error" id="dateErrorMessage">
        {{showAlternateErrorMessage && invalidDateMessageAlternate ? invalidDateMessageAlternate : invalidDateMessage}}
      </div>
    </div>
  }
  <button class="btn btn--white" (click)="onCalendarButtonClicked()" [disabled]="disabled">
    <svg>
      <use xlink:href="./assets/icons/connect-icons.svg#Calendar"></use>
    </svg>
  </button>
</div>

<div nc-calendar-picker [isModalOpen]="isDatePickerModalOpen" [selectedDate]="modalSelectedDate" (saveModal)="onDateModalSave($event)"
  [minDateString]="minDateString" [maxDateString]="maxDateString" [header]="calendarPickerHeader" (cancelModal)="onDateModalCancel()"
  (clearDateModal)="onDateClear()" [showDefaultMonthOnly]="isDateInputError">
</div>